import { Input, HostBinding, Directive } from '@angular/core'
import { arc } from 'd3'
import { GaugeComponentViewbox } from '../gauge-component-viewbox'

/**
 * @internal
 */
@Directive({
  selector: 'path[gpeiGaugeArc]',
  standalone: true
})
export class GaugeArcDirective {

  @HostBinding('style.transform')
  private readonly _hostStyle = `translate(${ GaugeComponentViewbox.CENTER }px, ${ GaugeComponentViewbox.CENTER }px)`

  /**
   * The outer radius of the gauge
   */
  @Input() outerRadius: number

  /**
   * The inner radius of the gauge
   */
  @Input() innerRadius: number

  private _startAngleDeg = 0
  private _endAngleDeg = 0

  /**
   * Generate a path for an arc of the gauge
   *
   * @returns           Returns an SVG path for the created arc
   */
  @HostBinding('attr.d')
  get path(): string {
    let generator = arc()
      .outerRadius(this.outerRadius)
      .innerRadius(this.innerRadius)
      .startAngle(this._startAngleDeg)
      .endAngle(this._endAngleDeg)

    return generator(null)
  }

  /**
   * The starting angle of the arc
   */
  @Input()
  set startAngle(value: number) {
    if (value) {
      this._startAngleDeg = GaugeArcDirective.degToRad(value)
    }
  }

  /**
   * The ending angle of the arc
   */
  @Input()
  set endAngle(value: number) {
    if (value) {
      this._endAngleDeg = GaugeArcDirective.degToRad(value)
    }
  }

  /**
   * Convert degrees to radians
   *
   * @param degree  The degree that will be converted
   *
   * @returns       Returns a number representing the converted value
   */
  static degToRad(degree: number): number {
    return degree * (Math.PI / 180)
  }

}
